<template>
    <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label required">Désignation</label>
                <div class="col-sm-8">
                    <input class="form-control form-control-sm" :id="'lotAutocomplete' + lot.uniq" type="text" :name="'lots[' + index + '][designation]'" v-model="lot.name" required> 
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label">Description</label>
                <div class="col-sm-8">
                    <textarea class="form-control" :id="'lots[' + index + '][description]'" :name="'lots[' + index + '][description]'" v-model="lot.description"></textarea>
                </div> 
            </div>
            <input type="hidden" class="form-control" :value="lot.id" :name="'lots[' + index + '][lot_id]'">
            <input type="hidden" class="form-control" :value="lot.name" :name="'lots[' + index + '][name]'">
            <input type="hidden" class="form-control" :value="lot.number" :name="'lots[' + index + '][number]'">
    </div>
</template>


<script>
export default {
    name: 'prediction-lot-form',
    props: ['lot', 'index', 'lotRoute'],
    data(){
        return {
            suggestionLots: []
        }
    },
    mounted(){
    },
   
}
</script>